export const getCurrentPosition = async (
  Dialog,
  { timeout, maximumAge = 0 } = {}
) => {
  try {
    const { Geolocation } = await import('Capacitor/@capacitor/geolocation')
    let permission = await Geolocation.checkPermissions()

    await new Promise(async (resolve) => {
      if (
        permission.location === 'denied' &&
        permission.coarseLocation === 'denied'
      ) {
        resolve()
      } else if (
        permission.location === 'prompt' ||
        permission.coarseLocation === 'prompt'
      ) {
        permission = await Geolocation.requestPermissions()
        resolve()
      } else if (
        permission.location === 'prompt-with-rationale' ||
        permission.coarseLocation === 'prompt-with-rationale'
      ) {
        Dialog({
          title: "Fonctionnement de l'alerte SOS",
          message:
            "Votre position n'est ni stockée, ni disponible en dehors de l'option alerte SOS. Veuillez accordez la permission d'accéder à votre localisation pour le bon fonctionnement de l'alertes SOS.",
          ok: { label: 'Continuer' }
        })
          .onOk(() => {})
          .onCancel(() => {})
          .onDismiss(async () => {
            permission = await Geolocation.requestPermissions()
            resolve()
          })
      } else {
        resolve()
      }
    })

    const hasLocationPermission =
      permission.location === 'granted' ||
      permission.coarseLocation === 'granted'
    if (!hasLocationPermission) {
      return null
    }

    const positionOptions = {
      enableHighAccuracy: true,
      maximumAge
    }
    if (timeout !== undefined) {
      positionOptions.timeout = timeout
    }

    const newPosition = await Geolocation.getCurrentPosition(positionOptions)
    if (newPosition) {
      const { longitude, latitude } = newPosition.coords
      return { longitude, latitude }
    }

    return null
  } catch (error) {
    return null
  }
}
